import JumbotronEpisode from './JumbotronEpisode'

export default JumbotronEpisode
// eslint-disable-next-line import/export
export * from './JumbotronEpisode'
